import { getAllMeetings, getMeetingById, initMeeting, addComment } from "@/api";
import Vue from "vue";
import formatDateFilter from "@/utils/formatDateFilter";

const initState = () => ({
  meetingList: [],

  page: 1,
  pageSize: 5,
  total: null,
  filter: [],
  search_query: "",

  accountOpenStep: 0,

  hasMeetingsBeforeFiltering: false,

  currentMeeting: null,
  currentMeetingId: null,

  // Секции доков
  fl: null,
  docs: null,
  meetingdocs: null,
  survey_accopen: null,

  template_fields_input: {},
  template_fields_filled: false,

  isTypicalStatute: null,

  accountSteps: {
    fl: {
      _priority: 0,
      title: "Паспорт представителя",
      component: "MeetingDetailsOpenAccountPassport",
      name: "send_fls",
    },
    survey_accopen: {
      _priority: 10,
      title: "Анкета",
      component: "MeetingDetailsOpenAccountForm",
      name: "survey_accopen",
    },
    mobile_id: {
      _priority: 20,
      title: "MobileID",
      component: "MeetingDetailsMobileId",
      name: "mobile_id",
    },
    digital_sign: {
      _priority: 30,
      title: "Электронное подписание",
      component: "MeetingDetailsFillFields",
      name: "template_fields",
    },
    meetingdocs: {
      _priority: 40,
      title: "Загрузка документов",
      component: "MeetingDetailsOpenAccountUpload",
      name: "send_docs",
    },
    plans: {
      _priority: 50,
      title: "Тарифы и опции",
      component: "MeetingDetailsOpenAccountPlans",
      name: "open",
    },
  },

  // Статусы
  statuses: {
    // желтые
    init: {
      label: "Назначена",
      bgColor: "#FAE6AA",
      textColor: "#B79310",
    },
    process: {
      label: "Ожидание обработки",
      bgColor: "#FAE6AA",
      textColor: "#B79310",
    },
    upload_fls: {
      label: "Загрузка паспортов",
      bgColor: "#FAE6AA",
      textColor: "#B79310",
    },
    upload_docs: {
      label: "Загрузка документов",
      bgColor: "#FAE6AA",
      textColor: "#B79310",
    },
    process_fls: {
      label: "Обработка паспортов",
      bgColor: "#FAE6AA",
      textColor: "#B79310",
    },
    process_docs: {
      label: "Обработка документов",
      bgColor: "#FAE6AA",
      textColor: "#B79310",
    },
    reupload_docs: {
      label: "Некорректные сканы",
      bgColor: "#F9C1BD",
      textColor: "#A61D1D",
      icon: "mdi-alarm-light-outline",
    },
    reupload_fls: {
      label: "Некорректные сканы",
      bgColor: "#F9C1BD",
      textColor: "#A61D1D",
      icon: "mdi-alarm-light-outline",
    },
    invalid_card_data: {
      label: "Некорректные данные карты",
      bgColor: "#F9C1BD",
      textColor: "#A61D1D",
      icon: "mdi-alarm-light-outline",
    },
    error: {
      label: "Ошибка",
      bgColor: "#F9C1BD",
      textColor: "#A61D1D",
    },
  },
  registration_status: {
    None: {
      text: "Отсутствует",
    },
    ApplicationForProduct: {
      text: "Заявка на продукт*",
    },
    ApplicationForRegistration: {
      text: "Заявка на регистрацию*",
    },
    PhoneConfirmed: {
      text: "Телефон подтвержден",
    },
    WaitingForConfirmation: {
      text: "Ожидание подтверждения*",
    },
    DelayedCheck: {
      text: "Отложенная проверка",
    },
    SearchInSpark: {
      text: "Поиск организации в справочнике СПАРК*",
    },
    NotFound: {
      text: "Компания не нашлась в справочниках",
    },
    ErrorSpark: {
      text: "Ошибка ФБР*",
    },
    WaitingEgrul: {
      text: "Ожидание ЕГРЮЛ",
    },
    ProcessingEgrul: {
      text: "Обработка ЕГРЮЛ",
    },
    CheckingCompany: {
      text: "Проверка юрлица",
    },
    ReservingAccount: {
      text: "Резервирование счета",
    },
    WaitingPassports: {
      text: "Ожидание загрузки паспортов",
    },
    WaitingDocs: {
      text: "Ожидание выписки",
    },
    ProcessingDocs: {
      text: "Обработка выписки",
    },
    ProcessingPassports: {
      text: "Обработка паспортов",
    },
    CheckingPersons: {
      text: "Проверка физлица",
    },
    CheckingPersonsAdditional: {
      text: "На доп. проверке физлиц",
    },
    EdsGeneration: {
      text: "Генерация ЭП*",
    },
    BeforeEdsGeneration: {
      text: "Перед генерацией ЭП*",
    },
    MeetingPreparation: {
      text: "Подготовка к встрече*",
    },
    ReadyForMeeting: {
      text: "Готово к встрече",
    },
    ReassignMeeting: {
      text: "Переназначить встречу",
    },
    Duplicate: {
      text: "Дубль заявки",
    },
    ClarifyDocs: {
      text: "Уточнение выписки (ТМ)",
    },
    BeforeProcessingEgrul: {
      text: "Обработка ЕГРЮЛ*",
    },
    BeforeCheckingCompany: {
      text: "Проверка юрлица*",
    },
    BeforeManualCheckingCompany: {
      text: "Ручная проверка юрлица*",
    },
    ManualCheckingCompany: {
      text: "Ручная проверка юрлица",
    },
    BeforeReservingAccount: {
      text: "Резервирование счета*",
    },
    BeforeProcessingDocs: {
      text: "Обработка выписки*",
    },
    BeforeProcessingPassports: {
      text: "Обработка паспортов*",
    },
    AfterProcessingOrganization: {
      text: "Обработка паспортов (ТМ)*",
    },
    SetStartCheckRepresentativeFbrStatus: {
      text: "Синхронизация ФБР-статусов представителей*",
    },
    FillIpInsteadOfStatement: {
      text: "Автоматическое заполнение данных ИП",
    },
    BeforeCheckingPersons: {
      text: "Проверка физлиц*",
    },
    EsiaSwitching: {
      text: "Регистрация через ESIA*",
    },
    CmPassportScansReceived: {
      text: "Обработка паспортов от КМ*",
    },
    ActualizeBeforeCheckingPersonsIfNeeded: {
      text: "Актуализация перед проверкой физлиц*",
    },
    AccOpeningDocPackageReady: {
      text: "Пакет документов на открытие счёта готов к обработке",
    },
    GenerationDocumentsArchive: {
      text: "Подготовка архива документов*",
    },
    DocumentsArchiveReady: {
      text: "Архив документов готов*",
    },
    BeforePodFtCheck: {
      text: "Проверка ПОД/ФТ*",
    },
    PodFtCheck: {
      text: "Проверка ПОД/ФТ",
    },
    BeforeAccountOpening: {
      text: "Открытие счета*",
    },
    AccountOpening: {
      text: "Открытие счета",
    },
    FillFromDadata: {
      text: "Заполнение данных из дадаты*",
    },
    DeferredAccountOpening: {
      text: "Отложенное открытие счета",
    },
    CheckFnsContainer: {
      text: "Проверка транспортного контейнера",
    },
    RegistrationUlInFns: {
      text: "Регистрация ЮЛ в ФНС",
    },
    RemovingReservedBankAccountOnOgrnOkopfChangeAfterEgrulProcessed: {
      text: "Удаление зарезервированного счета при смене ОГРН/ОКОПФ после обработки егрюл",
    },
    RemovingReservedBankAccountOnOkopfChangeAfterStatementProcessed: {
      text: "Удаление зарезервированного счета при смене ОКОПФ после обработки выписки",
    },
    CheckingOkved: {
      text: "Проверка ЮЛ уточнение ОКВЭД",
    },
  },
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    hasStatusFilter: (state) => state.filter.some((f) => f.field === "state"),
    dateFilter: (state) => {
      const filter = state.filter.find((f) => f.field === "dadd");
      return formatDateFilter(filter);
    },
    statusFilter: (state) => {
      // Здесь статус в поле 'state'
      const filter = state.filter.find((f) => f.field === "state");
      if (filter && filter.filters && filter.filters[0]) {
        return filter.filters[0].value;
      }
      // Дефолтное значение фильтра - all
      return "all";
    },
    showOpenAccountForm: (state) => !!state.currentMeeting?.assigned_user_id,
    hasMeetings: (state) => state.meetingList.length > 0,
    showCurrentMeeting: (state) => !!state.currentMeeting,
    accountOpenStepsCount: (state, getters) => getters.accountOpenSteps.length,
    fl: (state) => state.currentMeeting?.templatedata?.fl,
    docs: (state) => state.currentMeeting?.templatedata?.docs,
    meetingdocs: (state) => state.meetingdocs,
    survey_accopen: (state) => state.survey_accopen,
    survey_accopen_data: (state) => state.survey_accopen?.data,
    account_tariffs: (state) => state.currentMeeting?.templatedata?.account,
    tariffs: (state) => state.currentMeeting?.templatedata?.account.tariffs,
    template_fields: (state) => state.currentMeeting?.templatedata?.template_fields,
    wait_sign: (state) => state.currentMeeting?.templatedata?.wait_sign,
    // choosenTariffId: (state) => state.currentMeeting?.tariff_id,
    chosenTariff: (state) => state.currentMeeting?.tariff_alias,
    meetingCompanyName: (state) => state.currentMeeting?.company_name,
    interruptReason: (state) => state.currentMeeting?.interrupt_reason,
    cardData: (state) => state.currentMeeting?.card_data,
    // Вкладки
    accountOpenSteps: (state, getters) => {
      let output = [];
      if (getters.template_fields?.show === true) {
        output.push(state.accountSteps.digital_sign);
      }

      for (const docSection of ["fl", "meetingdocs"]) {
        if (getters[docSection]) {
          output.push(state.accountSteps[docSection]);
        }
      }

      if (state.currentMeeting?.templatedata?.mobile_id?.show === true) {
        output.push(state.accountSteps.mobile_id);
      }

      if (state.currentMeeting?.template?.survey_accopen) {
        output.push(state.accountSteps.survey_accopen);
      }

      if (state.currentMeeting?.template?.account) {
        output.push(state.accountSteps.plans);
      }

      return output.sort((a, b) => (a._priority > b._priority ? 1 : -1));
    },
    isCurrentStepFlDocs: (state, getters) => getters.accountOpenSteps[state.accountOpenStep]?.name === "send_fls",
    isCurrentStepMeetingDocs: (state, getters) => getters.accountOpenSteps[state.accountOpenStep]?.name === "send_docs",
    isCurrentStepSurvey: (state, getters) => getters.accountOpenSteps[state.accountOpenStep]?.name === "survey_accopen",
    isCurrentTemplateFields: (state, getters) =>
      getters.accountOpenSteps[state.accountOpenStep]?.name === "template_fields",
    isCurrentMobileId: (state, getters) => getters.accountOpenSteps[state.accountOpenStep]?.name === "mobile_id",
    isAllFlDocsUploaded: (state, getters) => {
      if (!Array.isArray(getters.fl)) {
        return false;
      }

      for (let person of getters.fl) {
        if (!Array.isArray(person.attachments)) {
          return false;
        }

        const result = person.attachments.every((attachment) => {
          const isRequired = attachment.properties?.is_required ?? false;
          const minFiles = attachment.properties?.min_files ?? 0;
          const totalUploadedFiles = attachment.files?.length ?? 0;

          return !(isRequired && (totalUploadedFiles === 0 || totalUploadedFiles < minFiles));
        });

        if (!result) {
          return false;
        }
      }
      return true;
    },
    isAllFlDocsSended: (state, getters) => {
      if (!Array.isArray(getters.fl)) {
        return false;
      }

      for (let person of getters.fl) {
        if (!person.sended) {
          return false;
        }
      }
      return true;
    },
    isAllMeetingDocsSended: (state, getters) => {
      if (!Array.isArray(getters.meetingdocs)) {
        return false;
      }

      return getters.meetingdocs.every((doc) => {
        if (doc.deny_upload) return true;

        return Boolean(doc.sended);
      });
    },
    isAllRequiredMeetingDocsUploaded: (state, getters) => {
      if (!Array.isArray(getters.meetingdocs)) {
        return false;
      }

      return getters.meetingdocs.every((doc) => {
        // FIXME: properties.min_files and etc.
        if (doc.is_required && !doc.sended) {
          if (doc.name === "statute" && state.isTypicalStatute) {
            return true;
          }

          return Boolean(doc.docs?.length);
        }

        return true;
      });
    },
    isSurveyAccopenFormed: (state, getters) => {
      if (!getters.survey_accopen) {
        return true;
      }

      if (!getters.survey_accopen_data) {
        return false;
      }

      const totalAnswers = Object.keys(getters.survey_accopen_data).length;
      return totalAnswers !== 0;
    },
    isTemplateFieldsFilled: (state, getters) => {
      if (!getters.template_fields) return true;
      if (!state.template_fields_input) return false;
      if (Object.keys(state.template_fields_input).length === 0) return false;

      return state.template_fields_filled;
    },

    // Степпер
    isAccountOpenFirstStepComplete: (state, getters) => getters.isAllFlDocsSended,
    isAccountOpenSecondStepComplete: (state, getters) => getters.isAllMeetingDocsSended,
    isSurveyStepComplete: (state, getters) => getters.survey_accopen?.passed,
    isSurveyCanSkip: (getters) => getters.survey_accopen?.can_skip,
    isMobileIdComplete: (state, getters) => state.currentMeeting?.templatedata?.mobile_id?.complete === true,
  },

  mutations: {
    setMeetingList: (state, payload) => (state.meetingList = payload),
    setPage: (state, payload) => (state.page = payload),
    setPageSize: (state, payload) => (state.pageSize = payload),
    setTotal: (state, payload) => (state.total = payload),
    setCurrentMeeting: (state, payload) => (state.currentMeeting = payload),
    setCurrentMeetingId: (state, payload) => (state.currentMeetingId = payload),
    setShowOpenAccountForm: (state, payload) => (state.showOpenAccountForm = payload),
    setFl: (state, payload) => (state.fl = payload),
    setDocs: (state, payload) => (state.docs = payload),
    setMeetingdocs: (state, payload) => (state.meetingdocs = payload),
    setHasMeetings: (state) => (state.hasMeetingsBeforeFiltering = true),
    setSurveyAccopen: (state, payload) => (state.survey_accopen = payload),
    setSurveyAccopenData: (state, payload) => {
      Vue.set(state, "survey_accopen", { ...state.survey_accopen, data: payload });
    },
    cleanTemplateFieldsInput: (state) => {
      state.template_fields_input = {};
      state.template_fields_filled = false;
    },
    setTemplateFieldsInput: (state, { document, input }) => {
      if (!state.template_fields_input[document]) {
        Vue.set(state.template_fields_input, document, input);
      } else {
        Vue.set(state.template_fields_input, document, { ...state.template_fields_input[document], ...input });
      }
    },
    setEntireTemplateFieldsInput: (state, data) => (state.template_fields_input = Object.assign({}, data)), // FIXME: бред
    setTemplateFieldsFilled: (state, isTrue) => {
      state.template_fields_filled = Boolean(isTrue);
    },
    setFlDocsFor: (state, payload) => {
      state.fl[payload.index].attachments = payload.docs || [];
    },
    setMeetingDocsFor: (state, payload) => {
      state.meetingdocs[payload.index].docs = payload.docs || [];
    },
    setAccountOpenStep: (state, payload) => {
      state.accountOpenStep = payload;
    },
    setSearchQuery: (state, payload) => {
      state.search_query = payload;
    },
    setStatusFilter: (state, payload) => {
      state.filter = state.filter.filter(({ field }) => field !== "state");

      if (payload && payload !== "all") {
        state.filter.push({
          field: "state",
          logic: "and",
          filters: [
            {
              operator: "eq",
              value: payload,
            },
          ],
        });
      }
    },
    setDateFilter: (state, payload) => {
      state.filter = state.filter.filter(({ field }) => field !== "dadd");

      const daddFilter = {
        field: "dadd",
        logic: "and",
        filters: [],
      };

      if (payload.start) {
        daddFilter.filters.push({
          operator: "gte",
          value: payload.start,
        });
      }
      if (payload.end) {
        daddFilter.filters.push({
          operator: "lte",
          value: payload.end,
        });
      }

      if (daddFilter.filters.length > 0) {
        state.filter.push(daddFilter);
      }
    },
    setTypicalStatute: (state, value) => (state.isTypicalStatute = value === null ? null : Boolean(value)),

    reset: (state) => {
      const initialState = initState();
      Object.keys(initialState).forEach((key) => (state[key] = initialState[key]));
    },
  },
  actions: {
    async getAllMeetings({ dispatch, commit, state: { page, pageSize, filter, search_query }, rootGetters }) {
      const response = await getAllMeetings({
        page,
        pageSize,
        filter,
        search_query,
      });
      if (response) {
        commit("setMeetingList", response.list || []);
        commit("setTotal", response.total);
      }
      return response;
    },

    async getMeetingById({ state, commit, getters }, id) {
      const meeting = await getMeetingById(id);

      if (meeting) {
        commit("cleanTemplateFieldsInput");
        commit("setCurrentMeeting", meeting);
        commit("setFl", meeting.templatedata?.fl || []);
        commit("setMeetingdocs", meeting.templatedata?.meetingdocs || []);
        commit("setSurveyAccopen", meeting.templatedata?.survey_accopen);

        if (id !== state.currentMeetingId) {
          // т.к. данные подтягиваются каждый раз при переходе из шага в шаг, то этот флаг перезатирается, хотя он ещё не закреплен на бэке
          // поэтому меняем только когда id не равен текущей открытой встрече
          commit("setTypicalStatute", meeting.template?.is_typical_statute);
        }

        if (meeting.templatedata?.template_fields?.input) {
          // FIXME: бредово выглядит
          commit("setEntireTemplateFieldsInput", meeting.templatedata.template_fields.input);
        }

        commit("setCurrentMeetingId", id);

        if (meeting.is_interrupted) {
          const interruptedStepIndex = getters.accountOpenSteps.findIndex(
            (step) => step.name === meeting.interrupt_step
          );
          if (interruptedStepIndex !== -1) {
            commit("setAccountOpenStep", interruptedStepIndex);
          }
        }
      }
      return meeting;
    },

    async initMeeting({ dispatch, state: { currentMeetingId } }) {
      const res = await initMeeting(currentMeetingId);
      if (res) {
        await dispatch("getMeetingById", currentMeetingId);
      }
    },

    async sendComment({ state: { currentMeetingId } }, text) {
      await addComment(currentMeetingId, text);
    },
  },
};
